import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ReactiveFormsModule, FormControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs/Rx';

import { ResponseService } from '../../../../../../services/response.service';
import * as Enum from '../../../../../../dtos/enums';

@Component({
    selector: 'text-entry-interaction',
    template: require('./text-entry-interaction.html')
})
export class TextEntryInteractionComponent implements OnInit, OnDestroy {
    @Input() interaction: PgRendererDto.InteractionDefinition;
    textEntryInteraction: PgRendererDto.TextEntryInteraction;
    width: number = 10;
    maxChar: number = 150;
    textEntryControl: FormControl;
    textEntryControlSubscription: Subscription;
    inputType: string = "text";
    placeHolderText: string = "";

    constructor(
        private responseService: ResponseService
    ) {
        this.textEntryControl = new FormControl("");
    }

    ngOnInit() {
        this.textEntryInteraction = this.interaction.TextEntryInteraction;
        if (this.textEntryInteraction.ExpectedLength) {
            this.width = this.textEntryInteraction.ExpectedLength;
        }
        if (this.textEntryInteraction.PlaceHolderText) {
            this.placeHolderText = this.textEntryInteraction.PlaceHolderText;
        }

        const response = this.responseService.getResponse(this.interaction);
        if (response && response.Items.length > 0) {
            this.textEntryControl.setValue(response.Items[0].Value);
        } else {
            this.responseService.setResponse(this.interaction, null, null, null, false, null);
        }

        if (this.textEntryInteraction.ResponseDeclaration && (this.textEntryInteraction.ResponseDeclaration.BaseType.toString() === Enum.BaseTypeEnum.Float.toString() || this.textEntryInteraction.ResponseDeclaration.BaseType.toString() === Enum.BaseTypeEnum.Integer.toString())) {
            this.inputType = "number";
        }

        this.textEntryControlSubscription = this.textEntryControl.valueChanges
            .debounceTime(1000)
            .distinctUntilChanged().subscribe(val => {
                this.responseService.setResponse(this.interaction, null, val, null, false, null);
        });
    }

    ngOnDestroy() {
        this.responseService.setResponse(this.interaction, null, this.textEntryControl.value, null, false, null);
        if (this.textEntryControlSubscription) {
            this.textEntryControlSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/text-entry-interaction/text-entry-interaction.component.ts